<template>
    <div v-if="loading">
      <loader></loader>
    </div>
    <div v-else>
      <div class="form">
          <div class="form-group">
              <label for="name">Nome</label>
              <input id="name" class="form-control" v-model="newField.name" placeholder="Nome">
          </div>
          <div class="form-group">
              <label for="description">Descrição</label>
              <textarea id="description" class="form-control" v-model="newField.description"
                        placeholder="Descrição"></textarea>
          </div>
          <div class="form-group" v-if="!hideRequired">
              <label for="required">Obrigatório</label>
              <input id="required" type="checkbox" v-model="newField.required" />
          </div>
          <div class="form-group">
              <label for="type">Tipo</label>
              <select id="type" class="form-control" v-model="newField.type" placeholder="Tipo" v-on:change="change()">
                  <option v-for="fieldType in fieldTypes" v-bind:value="fieldType">{{fieldType}}</option>
              </select>
          </div>
          <div class="form-group row" v-if="showFormula">
            <div class="col-md-12">
              <label for="formula">Fórmula</label>
              <textarea id="formula" v-model="newField.formula" class="form-control" rows="2" placeholder='Adicione uma fórmula aqui, considerando o NOME dos outros campos. Exemplo: concat( (Idade do Requisitante + 65).toString(), "anos"). Mais detalhes sobre as formulas http://mathjs.org/docs/index.html'></textarea>
            </div>
          </div>
          <div class="form-group">
            <label>Regras</label>
            <div class="panel panel-default">
              <div class="panel-body">
                <div v-if="rules.length === 0" class="alert alert-info">Nenhuma regra de redirecionamento</div>
                <div v-for="(rule, index) in rules" class="row">
                  <div class="col-sm-2">
                    <label>Operação</label>
                    <select class="form-control" v-model="rule.operation">
                      <option v-for="opt in fieldRules">{{opt}}</option>
                    </select>
                  </div>
                  <div class="col-sm-4">
                    <label>Argumento</label>
                    <input class="form-control" v-model="rule.argument">
                  </div>
                  <div class="col-sm-4">
                    <label>Ir para seção</label>
                    <multiselect v-model="rule.goto" label="name" track-by="objectId" :options="sections" :showLabels=false placeholder="Selecione uma opção"></multiselect>
                  </div>
                  <div class="col-sm-2">
                    <label>Ações</label>
                    <button class="btn btn-sm form-control btn-danger" @click="rules.splice(index, 1)">Remover</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <button class="btn btn-default pull-right" @click="rules.push({})">Adicionar Regra</button>
          </div>
          <div class="form-group row" v-if="show">
              <div class="col-md-6">
                <label for="select-items">Opções do select</label>
                <div class="text-muted">Adicione os items como linhas, com duas colunas separadas por ";" (ponto e vírgula). <b>Ex: 12345; Item de Exemplo</b></div>
                <textarea id="select-items" v-model="optionsCSV" class="form-control" rows="6" placeholder="Opções"></textarea>
              </div>
              <div class="col-md-6">
                <label>Resultado</label>
                <div class="text-muted">Verifique se os itens foram reconhecidos corretamente.</div>
                <table class="table table-bordered table-sprited">
                  <thead>
                    <tr>
                      <th>Identificador</th>
                      <th>Descrição</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in newField.options" :key="item.code">
                      <td>{{item.code}}</td>
                      <td>{{item.name}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
          </div>
      </div>
      <button id="btn-save-field" type="button" class="btn btn-primary" @click="save">Salvar</button>
      <button type="button" class="btn btn-default" @click="cancel">Cancelar</button>
    </div>
</template>

<script>

import { GlobalChannel, Parse, miniToastr } from '../Global'
import Loader from './util/Loader'
import Multiselect from 'vue-multiselect'
import { handleParseError } from './util/ErrorHandling'

export default {
  components: {
    Loader,
    Multiselect
  },
  data () {
    return {
      loading: false,
      show: false,
      showFormula: false,
      hideRequired: false,
      newField: { options: [], formula: '' },
      optionsCSV: '',
      fieldTypes: ['text', 'number', 'date', 'file', 'document', 'select', 'link', 'textarea', 'separator', 'checkbox', 'cpf', 'cnpj', 'phone', 'computed', 'money'],
      fieldRules: ['equals'],
      rules: [],
      sections: []
    }
  },
  mounted () {
    let id = this.$route.params.id
    if (id) {
      this.getById(id)
    } else {
      this.getFormSections()
    }
  },
  watch: {
    optionsCSV (newValue) {
      let list = []
      let lines = newValue.split('\n')
      lines.forEach(line => {
        if (line) {
          let columns = line.split(';')
          list.push({code: columns[0], name: columns[1]})
        }
      })
      this.newField.options = list
    }
  },
  methods: {
    change () {
      this.show = this.newField.type === 'select' || this.newField.type === 'checkbox'
      this.showFormula = this.newField.type === 'computed'
      this.hideRequired = this.newField.type === 'separator'
      if (this.hideRequired) {
        this.newField.required = false
      }
    },
    addNewField () {
      GlobalChannel.$emit('new_form_field')
    },
    getById (id) {
      let self = this
      self.loading = true
      let params = {
        formId: id
      }
      Parse.Cloud.run('getFormField', params).then(data => {
        let formField = data.formField
        self.rules = data.rules.map(r => r.toJSON())
        let props = ['name', 'description', 'type', 'required', 'options', 'formula']
        props.forEach(attr => {
          self.newField[attr] = formField.get(attr)
        })
        self.show = self.newField.type === 'select'
        self.hideRequired = self.newField.type === 'separator'
        if (self.hideRequired) {
          self.newField.required = false
        }
        let options = formField.get('options')
        let builder = []
        options.forEach((opt, i) => {
          if (i > 0) builder.push('\n')
          builder.push(opt.code)
          builder.push(';')
          builder.push(opt.name)
        })
        self.optionsCSV = builder.join('')
        return self.getFormSections()
      }).fail(error => {
        self.loading = false
        miniToastr.error(error.message)
      })
    },
    getFormSections () {
      let self = this
      let params = {
        requestId: self.$route.params.reqType
      }
      self.loading = true
      return Parse.Cloud.run('listFormSections', params).then(results => {
        self.sections = results.data.map(r => r.toJSON())
        self.loading = false
        self.change()
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    },
    cancel () {
      this.$router.go(-1)
    },
    save () {
      if (this.newField.type === undefined) {
        miniToastr.warn('Informe o tipo do campo.')
        return
      }
      let self = this
      self.loading = true
      let params = {
        requestId: self.$route.params.reqType,
        sectionId: self.$route.params.section,
        fieldId: self.$route.params.id,
        fieldData: self.newField,
        rulesData: self.rules
      }
      Parse.Cloud.run('saveFormField', params).then(results => {
        miniToastr.success('Salvo com sucesso')
        self.loading = false
        self.$router.go(-1)
      }).fail(error => {
        handleParseError(self, error)
        self.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// FormFieldDetail.vue?1eb1b4c8